import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  #accessToken = signal<string | null>(this.readStoredToken());

  readonly accessToken = this.#accessToken.asReadonly();
  readonly isAuthenticated = computed(() => !!this.#accessToken());

  setAccessToken(token: string | null): void {
    this.#accessToken.set(token);
    if (token) {
      localStorage.setItem('access_token', token);
    } else {
      localStorage.removeItem('access_token');
    }
  }

  clearAccessToken(): void {
    this.setAccessToken(null);
  }

  private readStoredToken(): string | null {
    return localStorage.getItem('access_token');
  }
}
